import { createFileRoute } from '@tanstack/react-router'
import { LiquidityMiningPage } from '@/features/mining/liquidity-mining/LiquidityMiningPage'

export const Route = createFileRoute('/_app/mining/liquidity')({
  component: LiquidityMiningPage,
})
